import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Modal } from "react-bootstrap";

import Input from "components/Input/index";
import Button from "components/Buttons/index";

import Icon from "components/Icon/Icon";
import { X, UserCircleGearIcon } from "@phosphor-icons/react";
import { CreatorVerifyModalStyles } from "./styled";
import RadioLabelComponent from "components/Toggles/RadioLabelComponent";
import LoadingSpinner from "components/PageLoader/Spinner";

import { useCreatorsVerificationSlice } from "./slice/index";
import { getVerifyInfo } from "./slice/selectors";
import { LinkText } from "components/SocialLinkDropdown/styled";

const CreatorVerifyModal = ({ show, onHide, rowData }) => {
  const dispatch = useDispatch();
  const { actions } = useCreatorsVerificationSlice();
  const { loading, success } = useSelector(getVerifyInfo);

  const secret_code = process.env.REACT_APP_SECRET_CODE;
  const [verifyInfo, setVerifyInfo] = useState({
    ig_name: "",
    ig_followers: "",
    ig_is_private: null
  });

  const handleVerify = () => {
    // Dispatch an action to verify the creator with the provided info
    dispatch(
      actions.verifyCreatorRequest({
        creator_user_id: rowData.creator_user_id,
        secret_code,
        ...verifyInfo
      })
    );
  };

  useEffect(() => {
    if (success) {
      onHide();
      setVerifyInfo({
        ...verifyInfo,
        ig_name: "",
        ig_followers: "",
        ig_is_private: null
      });
    }
  }, [success]);

  return (
    <CreatorVerifyModalStyles
      show={show}
      onHide={onHide}
      className="sidebar-modal"
      backdrop
      keyboard
      unmountOnExit
    >
      <Modal.Header>
        <Modal.Title>
          Verify Instagram for {rowData?.creator_user?.first_name}{" "}
          {rowData?.creator_user?.last_name}
        </Modal.Title>
        <div onClick={onHide} className="close-icon-wrapper">
          <Icon component={X} size={20} />
        </div>
      </Modal.Header>

      <Modal.Body>
        <div className="creators-innstagram-info">
          <div className="logo-text">
            <Icon
              component={UserCircleGearIcon}
              color="#797979"
              format="outline"
              weight="regular"
            />
            IG Handle
          </div>
          <LinkText
            className="main-text"
            onClick={() => window.open(rowData?.instagram_link, "_blank")}
          >
            {rowData?.instagram_handle}
          </LinkText>
        </div>

        <Input
          id="instagram_handle"
          label="Instagram Profile Name"
          placeholder="Enter Name in Instagram"
          type="text"
          value={verifyInfo.ig_name}
          onChange={(e) =>
            setVerifyInfo({ ...verifyInfo, ig_name: e.target.value })
          }
        />
        <div className="private-profile-wrapper">
          <h4>
            Does {rowData?.creator_user?.first_name}{" "}
            {rowData?.creator_user?.last_name} have a private profile?
          </h4>
          <div className="radio-wrapper">
            <RadioLabelComponent
              labelHeader="Yes"
              checked={verifyInfo.ig_is_private === true}
              onChange={() =>
                setVerifyInfo({ ...verifyInfo, ig_is_private: true })
              }
            />
            <RadioLabelComponent
              labelHeader="No"
              checked={verifyInfo.ig_is_private === false}
              onChange={() =>
                setVerifyInfo({ ...verifyInfo, ig_is_private: false })
              }
            />
          </div>
        </div>

        {verifyInfo.ig_is_private !== null && !verifyInfo.ig_is_private && (
          <Input
            label="Current follower count"
            id="ig_followers"
            placeholder="Enter total followers"
            type="number"
            min={0}
            value={verifyInfo.ig_followers}
            onChange={(e) => {
              const value = e.target.value;
              if (value === "" || Number(value)) {
                setVerifyInfo({
                  ...verifyInfo,
                  ig_followers: value
                });
              }
            }}
          />
        )}
      </Modal.Body>

      <Modal.Footer>
        <Button
          onClick={handleVerify}
          disabled={
            loading || !verifyInfo.ig_name || verifyInfo.ig_is_private === null
          }
        >
          {loading ? <LoadingSpinner size={20} /> : "Verify"}
        </Button>
      </Modal.Footer>
    </CreatorVerifyModalStyles>
  );
};

export default CreatorVerifyModal;
